// extracted by mini-css-extract-plugin
module.exports = {"Install":"install_Install__9YEH8","InstallButton":"install_InstallButton__fHu_J","InstallPopup":"install_InstallPopup__DJoKX","InstallClose":"install_InstallClose__FSXaF"};